var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
// https://gsap.com/community/forums/topic/25122-scrolltrigger-fade-image-in-place-scroll-text/
export default function TextMediaAnimationContainer(props) {
    var fields = props.fields, children = props.children;
    var MainTitleTag = (fields.titleTag || 'h1');
    var comp = useRef();
    var _a = useState(window.innerWidth < 768), isMobile = _a[0], setIsMobile = _a[1];
    var refreshScrollTrigger = function () {
        ScrollTrigger.refresh();
    };
    useEffect(function () {
        console.log("TextMediaAnimationContainer layout init");
        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
        //responsive
        var mm = gsap.matchMedia();
        var ctx = null;
        mm.add("(min-width: 768px)", function () {
            // create our context. This function is invoked immediately and all GSAP animations and ScrollTriggers created during the execution of this function get recorded so we can revert() them later (cleanup)
            ctx = gsap.context(function () {
                var points = gsap.utils.toArray('.spa-text-media-animation-item');
                var height = 45 * points.length;
                var tl = gsap.timeline({
                    duration: (points).length,
                    scrollTrigger: {
                        //toggleActions: "resume pause reverse pause",
                        trigger: comp.current && comp.current.querySelector(".spa-text-media-animation .wrapper"),
                        start: function () { return "-30% top"; },
                        end: function () { return "+=" + height + "%"; },
                        scrub: true,
                        id: "items",
                        markers: false
                    }
                });
                var pinner = gsap.timeline({
                    scrollTrigger: {
                        trigger: comp.current && comp.current.querySelector(".spa-text-media-animation .wrapper"),
                        start: "top top",
                        end: function () { return "+=" + (height) + "%"; },
                        scrub: true,
                        pin: comp.current && comp.current.querySelector(".spa-text-media-animation .wrapper"),
                        pinSpacing: true,
                        id: "pinning",
                        markers: false,
                    }
                });
                //
                var maxTextElHeight = 0;
                points.forEach(function (elem, i) {
                    var elHeight = elem.querySelector('.text-container').offsetHeight;
                    if (elHeight > maxTextElHeight) {
                        maxTextElHeight = elHeight;
                    }
                });
                var eleHeight = maxTextElHeight + 50;
                points.forEach(function (elem, i) {
                    gsap.set(elem, { position: "absolute", top: 0 });
                    if (i != 0) {
                        tl.from(elem.querySelector('.text-container'), {
                            css: { 'opacity': 0.5, 'zIndex': 0, 'translateY': eleHeight, translateX: 0, 'filter': 'grayscale(1)', '-webkit-filter': 'grayscale(1)' },
                            /* autoAlpha: 0.5, translateY: 250, translateX: 100,*/
                            //onComplete: function () {
                            //}
                        }, i - 0.25);
                        tl.from(elem.querySelector('.text-container'), {
                            css: { 'opacity': 0, 'zIndex': 0, translateY: eleHeight * 2, translateX: 0, 'filter': 'grayscale(1)', '-webkit-filter': 'grayscale(1)' },
                            /*     autoAlpha: 0, translateY: 500, translateX: 100,*/
                            //onComplete: function () {
                            //}
                        }, i - 1.25 < 0 ? 0 : i - 1.25);
                        //tl.from(elem.querySelector('.img-container'), { autoAlpha: 0 }, i);
                        tl.from(elem.querySelector('.img-container'), { ease: "power1.out", css: { 'opacity': 0, 'scale': 0.3, translateY: eleHeight, 'filter': 'grayscale(1)', '-webkit-filter': 'grayscale(1)' } }, i - 0.25);
                    }
                    tl.addLabel('position-' + i); // Adding a label here, with the index as unique identifier
                    if (i != points.length - 1) {
                        tl.to(elem.querySelector('.text-container'), {
                            css: { opacity: 0.5, 'zIndex': 0, translateY: -eleHeight, translateX: 0, 'filter': 'grayscale(1)', '-webkit-filter': 'grayscale(1)' },
                            /*autoAlpha: 0.5, translateY: -250, translateX: 100,*/
                            //onComplete: function () {
                            //}
                        }, i + 0.75);
                        if (i != points.length - 2) {
                            tl.to(elem.querySelector('.text-container'), {
                                css: { opacity: 0, 'zIndex': 0, translateY: -2 * eleHeight, 'filter': 'grayscale(1)', '-webkit-filter': 'grayscale(1)' },
                                /*  autoAlpha: 0, translateY: -500,*/
                                onComplete: function () {
                                    //var element = elem.querySelector('.text-container');
                                    //element && (element.style.filter = "grayscale(0)");
                                }
                            }, i + 1.75);
                        }
                        //tl.to(elem.querySelector('.img-container'), { autoAlpha: 0 }, i + 0.75);
                        tl.to(elem.querySelector('.img-container'), { ease: "power1.out", css: { opacity: 0, scale: 0.3, translateY: -320, 'filter': 'grayscale(1)', '-webkit-filter': 'grayscale(1)' } }, i + 0.75);
                    }
                    // const text = elem.querySelector('p')
                    //ScrollTrigger.create({
                    //    trigger: ".spa-text-media-animation-item",
                    //    start: "top top", // + ((110 * i) + 50)
                    //    end: "+=33%",
                    //    //   toggleClass: { targets: elem, className: "active" },
                    //    onEnter: () => {
                    //        //console.log("go to section:", i);
                    //    },
                    //    onEnterBack: () => {
                    //        //console.log("go to section back:", i);
                    //    }
                    //})
                    //ScrollTrigger.create({
                    //    trigger: elem,
                    //    toggleClass: { className: "active" },                   
                    //    onEnter: () => { console.log("go to section:", i); }
                    //});
                    //ScrollTrigger.create({
                    //    trigger: elem,
                    //    start: "bottom bottom",
                    //    toggleClass: { className: "active" }, 
                    //    onEnterBack: () => { console.log("go to section back:", i); }
                    //});
                });
                //
                // Our animations can use selector text like ".box" 
                // this will only select '.box' elements that are children of the component
                //gsap.to(".box", { ...});
                // or we can use refs
                // gsap.to(circle.current, { rotation: 360 });
            }, comp); // <- IMPORTANT! Scopes selector text
            document.addEventListener("DOMContentLoaded", refreshScrollTrigger);
            // Watch for image load and refresh ScrollTrigger
            var images = document.querySelectorAll('.strip img');
            images && images.forEach(function (image) {
                image.addEventListener('beforeload', refreshScrollTrigger);
                image.addEventListener('load', refreshScrollTrigger);
            });
        });
        var handleResize = function () {
            setIsMobile(window.innerWidth < 768);
        };
        // Add event listener for window resize
        window.addEventListener('resize', handleResize);
        var handleWindowLoad = function () {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            });
        };
        window.addEventListener('load', handleWindowLoad);
        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        });
        return function () {
            ctx && ctx.revert();
            mm && mm.revert();
            document.removeEventListener("DOMContentLoaded", refreshScrollTrigger);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('load', handleWindowLoad);
        };
        // cleanup       
    }, []); // <- empty dependency Array so it doesn't re-run on every render!
    //initial={{ opacity: 0 }}
    //  whileInView={{ opacity: 1 }}
    //  viewport={{ once: true, margin: "-30%" }}
    return (React.createElement(React.Fragment, null,
        React.createElement(motion.div, __assign({ ref: comp, initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip spa-text-media-animation position-relative"
                + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
                + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
                + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
                + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
                + ((fields.backgroundColour) ? (" bg-" + fields.backgroundColour) : "")
                + ((fields.textColour) ? (" text-color-" + fields.textColour) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {}), { style: {
                "position": "relative",
                "display": isMobile ? "none" : ""
            } }),
            React.createElement("div", { className: "container-fluid " },
                fields.displayTitle && React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement(MainTitleTag, { className: "strip-title " + (fields.titleStyle ? fields.titleStyle : ""), dangerouslySetInnerHTML: { __html: fields.displayTitle } }))) || null,
                React.createElement("div", { className: "wrapper" },
                    React.createElement("div", { className: "inner" }, children && children.map(function (item, j) {
                        var TitleTag = (item.fields.titleTag || 'h1');
                        var isWebmFile = item.fields.image.toLowerCase().includes('webm') || false;
                        return (React.createElement("div", { className: "spa-text-media-animation-item", key: j },
                            React.createElement("div", { className: "text-container" },
                                item.fields.icon && React.createElement("div", { className: "icon-wrapper" },
                                    React.createElement("img", { className: "icon", src: item.fields.icon, alt: item.fields.iconTitle || item.fields.displayTitle }),
                                    item.fields.iconLabel && React.createElement("div", { className: "icon-title", style: {
                                            background: '-webkit-linear-gradient(257deg,' + item.fields.color1 + ', ' + item.fields.color2 + ')',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent'
                                        } }, item.fields.iconLabel)) || null,
                                item.fields.displayTitle && React.createElement("div", { className: "icon-title", style: {
                                        background: '-webkit-linear-gradient(257deg,' + item.fields.titleColor1 + ', ' + item.fields.titleColor2 + ')',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent'
                                    } },
                                    React.createElement(TitleTag, { className: "title " + (item.fields.titleStyle ? item.fields.titleStyle : '') }, item.fields.displayTitle)) || null,
                                React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: item.fields.content } })),
                            React.createElement("div", { className: "img-container rounded-circle overflow-hidden" + (isWebmFile ? " has-webm position-relative" : "") },
                                !isWebmFile && React.createElement("img", { src: item.fields.image, alt: item.fields.title }) || null,
                                isWebmFile && React.createElement(React.Fragment, null,
                                    React.createElement("video", { className: "position-absolute object-fit-cover top-0 start-0", autoPlay: true, loop: true, muted: true, style: { width: '100%', height: '100%' } },
                                        React.createElement("source", { src: item.fields.image, type: "video/webm" }),
                                        "Your browser does not support the video tag."),
                                    React.createElement("img", { src: "/getmedia/c463e2c8-b8a4-4d74-8e0f-a5fe474707c8/RC-Blank.png?width=692&height=692&ext=.png" })) || null)));
                    }))))),
        isMobile && React.createElement("div", __assign({ className: "strip spa-text-media-animation position-relative"
                + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
                + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
                + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
                + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
                + ((fields.backgroundColour) ? (" bg-" + fields.backgroundColour) : "")
                + ((fields.textColour) ? (" text-color-" + fields.textColour) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
            React.createElement("div", { className: "container-fluid " },
                fields.displayTitle && React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement(MainTitleTag, { className: "strip-title " + (fields.titleStyle ? fields.titleStyle : ""), dangerouslySetInnerHTML: { __html: fields.displayTitle } }))) || null,
                React.createElement(Swiper, { slidesPerView: 'auto', spaceBetween: 30, onSlideChange: function () { return console.log('slide change'); }, onSwiper: function (swiper) { return console.log("on swiper: ", swiper); } }, children && children.map(function (item, j) {
                    return (React.createElement(SwiperSlide, { key: j },
                        React.createElement("div", { className: "spa-text-media-animation-item" },
                            React.createElement("div", { className: "text-container" },
                                item.fields.icon && React.createElement("div", { className: "icon-wrapper" },
                                    React.createElement("img", { className: "icon", src: item.fields.icon, alt: item.fields.iconTitle || item.fields.displayTitle }),
                                    item.fields.iconLabel && React.createElement("div", { className: "icon-title", style: {
                                            background: '-webkit-linear-gradient(257deg,' + item.fields.color1 + ', ' + item.fields.color2 + ')',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent'
                                        } }, item.fields.iconLabel)) || null,
                                item.fields.displayTitle && React.createElement("div", { className: "icon-title", style: {
                                        background: '-webkit-linear-gradient(257deg,' + item.fields.titleColor1 + ', ' + item.fields.titleColor2 + ')',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent'
                                    } },
                                    React.createElement("div", { className: "title" }, item.fields.displayTitle)) || null,
                                React.createElement("div", { className: "content", dangerouslySetInnerHTML: { __html: item.fields.content } })),
                            React.createElement("div", { className: "img-container" },
                                React.createElement("img", { src: item.fields.image, alt: item.fields.title })))));
                })))) || null));
}
